export default __webpack_public_path__ + "static/media/watches15.6917a84c.jfif";